module.exports = __webpack_public_path__ + "img/shield-info-icon.62591da9.svg";